module.exports = __webpack_public_path__ + "static/lighthouse_staircase-b5ac1aa7d4bd03b7b223dbcdfb2f026e.jpg";